import { Stack } from "@mui/material";

import React from "react";

import Tag, { BasicTag } from "../../Atoms/Tag";

export type Props = {
    tags?: BasicTag[];
};

const Tags = ({ tags }: Props) => (
    <Stack
        direction="row"
        spacing={1}
        sx={{
            margin: [2, 0]
        }}
    >
        {tags &&
            tags.map((tag) => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <Tag {...tag} key={tag.slug} />
            ))}
    </Stack>
);

Tags.defaultProps = {
    tags: []
};

export default Tags;
